/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { CustomizationFontDefinition, FontFamily, FontWeight, List, StorageFileKey } from "./data-contracts";

/**
 * No description
 * @tags custom-fonts
 * @name ListCustomFonts
 * @summary List all custom fonts
 * @request GET:/orgs/{organizationId}/fonts
 * @secure
 */

// @ts-ignore
export const listCustomFonts: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: CustomizationFontDefinition[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/fonts",
  method: "get",
  streaming: false,
  tags: ["custom-fonts"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags custom-fonts
 * @name CreateCustomFont
 * @summary Create a custom font
 * @request PUT:/orgs/{organizationId}/fonts
 * @secure
 */

// @ts-ignore
export const createCustomFont: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The human-readable font-family name used in CSS (e.g., "Open Sans", "Playfair Display"). */
    fontFamily: FontFamily;
    /**
     * Array of font faces specifying weights and their corresponding storage keys.
     * At least one font face with weight 400 (regular) must be provided.
     * @minItems 1
     */
    fontFaces: {
      /** Numeric representation of the font weight (400=regular, 500=medium, 700=bold, 900=black). */
      weight: FontWeight;
      /** The path of the file in the storage bucket */
      storageKey: StorageFileKey;
    }[];
  };
  RequestHeaders: {};
  ResponseBody: CustomizationFontDefinition;
  ResponseStatusCode: 201 | 404 | 412;
} = {
  route: "/orgs/{organizationId}/fonts",
  method: "put",
  streaming: false,
  tags: ["custom-fonts"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags custom-fonts
 * @name GetCustomFont
 * @summary Get a custom font by its ID
 * @request GET:/orgs/{organizationId}/fonts/{fontId}
 * @secure
 */

// @ts-ignore
export const getCustomFont: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of a font */
    fontId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CustomizationFontDefinition;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/fonts/{fontId}",
  method: "get",
  streaming: false,
  tags: ["custom-fonts"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags custom-fonts
 * @name UpdateCustomFont
 * @summary Update a custom font
 * @request POST:/orgs/{organizationId}/fonts/{fontId}
 * @secure
 */

// @ts-ignore
export const updateCustomFont: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of a font */
    fontId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The human-readable font-family name used in CSS (e.g., "Open Sans", "Playfair Display"). */
    fontFamily?: FontFamily;
    /** Array of font faces specifying weights and their corresponding storage keys. Passing null as the storage key will remove that weight. */
    fontFaces?: {
      /** Numeric representation of the font weight (400=regular, 500=medium, 700=bold, 900=black). */
      weight: FontWeight;
      storageKey: StorageFileKey | null;
    }[];
  };
  RequestHeaders: {};
  ResponseBody: CustomizationFontDefinition;
  ResponseStatusCode: 201 | 404 | 412;
} = {
  route: "/orgs/{organizationId}/fonts/{fontId}",
  method: "post",
  streaming: false,
  tags: ["custom-fonts"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags custom-fonts
 * @name DeleteCustomFont
 * @summary Delete a custom font
 * @request DELETE:/orgs/{organizationId}/fonts/{fontId}
 * @secure
 */

// @ts-ignore
export const deleteCustomFont: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of a font */
    fontId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/fonts/{fontId}",
  method: "delete",
  streaming: false,
  tags: ["custom-fonts"],
  criticalityLevel: "low",
  deprecated: false,
};
